import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'

class CostBearingDepartmentDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        const { id, advanceExpenseID } = this.props
        Tyan.doPostEvent({
            event: 'GetCostBearingDep',
            data: { id, advanceExpenseID },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onSave, advanceExpenseID } = this.props
        const { id, changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveCostBearingDep',
            data: { id, advanceExpenseID, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteCostBearingDep',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handleChange = () => {
        const 部门分摊金额 = getFormValue(this, '基本信息', '部门分摊金额')
        const 预支金额 = getFormValue(this, '基本信息', '预支金额')
        const 报支金额 = getFormValue(this, '基本信息', '报支金额')
        var d部门分摊比例 = 100
        if (部门分摊金额) {
            if (报支金额)
                d部门分摊比例 = 部门分摊金额 / 报支金额 * 100
            else if (预支金额)
                d部门分摊比例 = 部门分摊金额 / 预支金额 * 100
        }
        changeItemsValue(this, '基本信息', ['部门分摊比例'], [`${Math.floor(d部门分摊比例)}%`])
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '部门分摊金额') &&
            getFormValue(this, '基本信息', '成本承担部门')
    }

    fieldset基本信息 = () => {
        return [
            { _select: '成本承担部门', minWidth: '95%', required: true, editable: true, },
            { _float: '部门分摊金额', minWidth: '95%', required: true, onChange: this.handleChange, textAlign: 'left' },
            { _text: '部门分摊比例', minWidth: '95%', disabled: true, },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="700"
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ] :
                    [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(this.canSave() && this.bChanged()), },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete, disabled: this.bChanged() },
                        { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
                ]
            }
        />
    }
}

export default connect()(CostBearingDepartmentDiv)